module.exports = __webpack_public_path__ + "img/3-4.920d1017.svg";